export function addClasses(...args: string[]): string {
  return args.filter((item) => !!item).join(" ");
}

/**
 * Finds if any element of targetArray is inside sourceArray
 *
 * @param {Array<string>} sourceArray - Array of strings
 * @param {Array<string>} targetArray - Array of strings
 * @param {boolean} [all=false]
 * @returns {boolean}
 */
export function listIncludes<T>(sourceArray: T[], targetArray: T[], all: boolean = false): boolean {
  if (!targetArray) {
    console.warn("list includes : empty target");
    return false;
  }
  if (all) {
    return targetArray.every((item) => sourceArray.includes(item));
  }
  return targetArray.some((item) => sourceArray.includes(item));
}

export function hasAnyItems<T>(sourceArray: T[], ...items: T[]): boolean {
  if (!items) {
    console.warn("has any items : empty target");
    return false;
  }
  return items.some((element) => sourceArray.includes(element));
}

export function oneOf<T>(item: T, list: T | T[], ...rest: T[]): boolean {
  if (!list) {
    console.warn("oneOf : empty list");
    return false;
  }
  if (Array.isArray(list)) {
    return list.includes(item);
  }
  const items = [list, ...rest];
  return items.includes(item);
}

export function hasAction(campaign: any, type: string): any {
  return campaign?.actions?.find((action: any) => action.type === type);
}

export function isAdmin(user: { profile?: string } | null | undefined): boolean {
  return user?.profile === "ADMIN";
}

export function isBooster(user: { profile?: string } | null | undefined): boolean {
  return user?.profile === "BOOSTER" && !window.premium;
}

export function csvLength(file: File | null | undefined, setter: (count: number) => void): void {
  if (file) {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      if (typeof result === "string") {
        setter(result.split("\n").length - 2);
      }
    };
    reader.readAsText(file);
  } else {
    setter(0);
  }
}
